/** Share helpers for Challenge Ticket — clipboard, SMS, Web Share API. */

export const CHALLENGE_TICKET_SHARE_TITLE = 'LockedIn Challenge Ticket';

export const RISKY_TICKET_COPY_TERMS = /\b(bet|wager|gambling|odds|winnings|escrow|sportsbook)\b/i;

export function assertChallengeTicketCopy(text) {
  return !RISKY_TICKET_COPY_TERMS.test(String(text || ''));
}

export function buildSmsUri(body) {
  return `sms:?&body=${encodeURIComponent(String(body || ''))}`;
}

export async function copyTextToClipboard(text) {
  await navigator.clipboard.writeText(String(text || ''));
}

export function openSmsWithBody(body) {
  if (typeof window === 'undefined') return;
  window.location.href = buildSmsUri(body);
}

export async function shareChallengeTicket({ title, text, url }) {
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    await navigator.share({
      title: title || CHALLENGE_TICKET_SHARE_TITLE,
      text: text || '',
      url: url || undefined,
    });
    return 'shared';
  }
  return 'unsupported';
}
